import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { nsButtonStyles } from '../ns-styles/index.js';
import '../ns-icon/ns-icon.js';
import '@awesome.me/webawesome/dist/components/button/button.js';

@customElement('ns-empty-state')
export class NSEmptyState extends LitElement {
  @property({ type: String })
  message = '';

  @property({ type: String })
  secondary?: string;

  @property({ type: String })
  icon?: string;

  @property({ type: String, attribute: 'action-label' })
  actionLabel?: string;

  static styles = [
    nsButtonStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: var(--wa-space-xs);
        padding: var(--wa-space-2xl) var(--wa-space-m);
        text-align: center;
      }

      :host([hidden]) {
        display: none;
      }

      ns-icon {
        --icon-height: 40px;
        --icon-width: 40px;

        margin-bottom: var(--wa-space-2xs);
        opacity: 0.5;
      }

      .message {
        font-size: var(--ns-empty-state-message-size, var(--wa-font-size-m));
        font-weight: 600;
      }

      .secondary {
        font-size: var(--wa-font-size-s);
        opacity: 0.7;
      }
    `,
  ];

  private __action() {
    this.dispatchEvent(new CustomEvent('action', { bubbles: true, composed: true }));
  }

  render() {
    return html`
      <slot name="media">
        ${this.icon
          ? html`
              <ns-icon icon=${this.icon} aria-hidden="true"></ns-icon>
            `
          : nothing}
      </slot>
      <span class="message">${this.message}</span>
      ${this.secondary
        ? html`
            <span class="secondary">${this.secondary}</span>
          `
        : nothing}
      ${this.actionLabel
        ? html`
            <wa-button variant="brand" size="s" type="button" @click=${this.__action}>${this.actionLabel}</wa-button>
          `
        : nothing}
    `;
  }
}
